// ./src/components/features/EventVendors/RequirementBadges.tsx
//
// ROADMAP #170 — a request's state and what needs a look, as two badges (the list, the vendor's page and the review drawer
// show the same ones).
import React from "react";
import { Badge, Group } from "@mantine/core";

import { EventVendorRequirement, VENDOR_REQUIREMENT_STATUS } from "@/utils/api";

import { ATTENTION_LABEL, REQUIREMENT_STATUS_COLOR, REQUIREMENT_STATUS_LABEL } from "./vendorUi";

export const RequirementBadges: React.FC<{ requirement: EventVendorRequirement }> = ({ requirement }) => {
  const status = requirement.reviewStatus ?? VENDOR_REQUIREMENT_STATUS.MISSING;

  return (
    <Group gap={6} wrap="wrap">
      <Badge size="md" variant="light" color={REQUIREMENT_STATUS_COLOR[status] ?? "gray"}>
        {REQUIREMENT_STATUS_LABEL[status] ?? status}
      </Badge>
      {requirement.attention ? (
        <Badge size="md" variant="light" color="red">
          {ATTENTION_LABEL[requirement.attention] ?? requirement.attention}
        </Badge>
      ) : null}
    </Group>
  );
};
